import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NlpComponent } from './nlp.component';
import { NlpExampleComponent } from './nlp-example/nlp-example.component';
import { NlpQuestionComponent } from './nlp-question/nlp-question.component';
import { WordsegmentComponent } from '../nlp/wordsegment/wordsegment.component';

const routes: Routes = [
  {
    path:'',
    component: NlpComponent,
    children: []
  },
  {
    path:'example',
    component: NlpExampleComponent,
    children: []
  },
  {
    path:'question',
    component: NlpQuestionComponent,
    children: []
  },
  {
    path:'wordsegment',
    component: WordsegmentComponent,
    children: []
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class NlpRoutingModule { }
